import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SpEnvironmentType } from "InterfacesTypes/types";

export interface ISPEnvironmentState {
    spEnvironment: SpEnvironmentType;
    initialized: boolean;
    error: string | null;
}

const initialState: ISPEnvironmentState = {
    spEnvironment: "logistikportalen",
    initialized: false,
    error: null,
}

export const spEnvironmentSlice = createSlice({
    name: "spEnvironment",
    initialState,
    reducers: {
        setSpEnvironment(state, action: PayloadAction<SpEnvironmentType>) {
            state.spEnvironment = action.payload;
        },
        markInitialized(state) {
            state.initialized = true;
        },
        loadSpEnvironment() {

        },
    },
});

export const {
    setSpEnvironment,
    markInitialized,
    loadSpEnvironment,
} = spEnvironmentSlice.actions;

export const SPEnvironmentReducer = spEnvironmentSlice.reducer;